(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/ticket-on-podium.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/ticket-on-podium.js');
'use strict';

const Ticket = svs.tickets.next.components.Ticket;
const buttonWrapperStyle = {
  display: 'block',
  textAlign: 'center',
  background: 'transparent',
  position: 'relative',
  aspectRatio: '16 / 9',
  color: 'inherit',
  font: 'inherit',
  margin: 0,
  width: '100%',
  maxWidth: 'inherit',
  padding: 0,
  paddingBottom: '20%',
  cursor: 'pointer',
  appearance: 'none',
  border: 'none'
};
const podiumStyle = {
  position: 'absolute',
  left: '-30px',
  right: '-30px',
  bottom: '0px',
  top: 'auto'
};
const TicketOnPodium = _ref => {
  let ticketType = _ref.ticketType,
    onClick = _ref.onClick,
    image = _ref.image;
  return React.createElement("button", {
    className: "qa-ticket-on-podium",
    onClick: onClick,
    style: buttonWrapperStyle,
    type: "button"
  }, React.createElement(Ticket, {
    image: image,
    ticketType: ticketType
  }), React.createElement("img", {
    alt: "Podium",
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets/next-gen/podium-shadowed-small.png"),
    style: podiumStyle
  }));
};
setGlobal('svs.tickets.next.components.TicketOnPodium', TicketOnPodium);

 })(window);